import {useEffect} from 'react'
import Header from 'src/biz/Header'
import LeftMenu from 'src/biz/LeftMenu'
import styles from './index.module.scss'
export const Layout = (props: any = {}) => {
  useEffect(() => {}, [])
  return (
    <div className={styles.layout}>
      <Header />
      <div className={styles.main}>
        <LeftMenu groups={[]} menu={[]} />
        <div className={styles.right}></div>
      </div>
    </div>
  )
}
export default Layout
